export default __webpack_public_path__ + "static/media/bg2.6c9ac26d.png";